import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import TransitionExpand from '../../ui/TransitionExpand.vue';
import LegendOptions from '@/components/docs-main/reference-pages/LegendOptions.vue';
import { uppercaseKinds } from '@/heplers';
import { useRoute } from '@/heplers/useRoute';


export default /*#__PURE__*/_defineComponent({
  __name: 'Legend',
  props: {
    legendData: null
  },
  setup(__props: any) {



const route = useRoute();
const showLegend = ref(true);
const expanded = ref(true);

const chevronStateClass = computed(() => {
  return expanded.value ? 'chevron-open' : 'chevron-close';
});

const isIntroduction = computed(() => {
  return route.value?.meta?.fqdn?.split('.')[0] === 'introduction';
});

const computeReferencesDataName = computed(() => {
  return isIntroduction.value ? 'Table of content' : 'Reference map';
});

const capitalizeName = (name: string) => {
  return uppercaseKinds[name];
};

const computeKindName = (kind: string) => {
  if (!isIntroduction.value) return capitalizeName(kind);

  if (kind === 'tutorial') return 'Articles';

  if (kind === 'folder') return 'Chapters';

  return capitalizeName(kind);
};

return { __sfc: true,route, showLegend, expanded, chevronStateClass, isIntroduction, computeReferencesDataName, capitalizeName, computeKindName, TransitionExpand, LegendOptions }
}

})